<template>
  <div class="gauge-chart" ref="chartRef" style="width: 100%; height: 300px;"></div>
</template>

<script>
import * as echarts from 'echarts'
import { getPositionCompletionRate, getallStaffEfficiency } from "../api";

import { extractTitleAndValueArrays } from "@/basic-common/util/common";
export default {
  name: 'GaugeChart',
  inject: ['parentThat'],
  data () {
    return {
      chart: null,
      taskCompletionRate: 0,
    }
  },
  mounted () {
    // 初始化图表
    this.chart = echarts.init(this.$refs.chartRef)
    this.setChartOption()

    // 监听窗口大小变化，实现自适应
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    // 组件销毁时移除事件监听，避免内存泄漏
    window.removeEventListener('resize', this.handleResize)
    if (this.chart) {
      this.chart.dispose()
    }
  },
  methods: {
    setChartOption () {
      const { queryForm } = this.parentThat
      getallStaffEfficiency(queryForm).then(({ data }) => {
        this.setOption(data.data.taskCompletionRate || 0)
      })
    },
    setOption (value) {
      const option = {
        title: {
          text: '整体完成率',
          left: '10%',
          top: '5%'
        },
        series: [
          {
            type: 'gauge',
            radius: '80%',
            center: ['50%', '60%'],
            startAngle: 180,
            endAngle: 0,
            min: 0,
            max: 100,
            splitNumber: 10,
            axisLine: {
              lineStyle: {
                width: 15,
                color: [
                  [0.2, '#ff4d4f'],
                  [0.8, '#ffc800'],
                  [1, '#00b42a']
                ]
              }
            },
            pointer: {
              length: '60%',
              lineStyle: {
                width: 5
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              distance: 20,
              color: '#666'
            },
            detail: {
              formatter: '{value}%',
              fontSize: 24,
              color: '#ffc800',
              offsetCenter: [0, '30%']
            },
            // 调整name的位置和样式
            data: [{
              value: value,
              name: '',
              nameTextStyle: {
                fontSize: 14,
                color: '#666',
                offset: [0, -50] // 向上调整name位置
              }
            }]
          }
        ]
      }
      this.chart.setOption(option)
    },
    handleResize () {
      if (this.chart) {
        this.chart.resize()
      }
    }
  }
}
</script>
